import Vue from 'vue'
import Router from 'vue-router'
import Cookies from 'js-cookie'
import home from '@/page/home/home.vue'

Vue.use(Router)

export default new Router({
  base: '/', // 基础路径
  // mode: 'history',
  routes: [{
      path: '/',
      name: 'home',
      component: home,
      meta: {
        title: "首页"
      },
    }, 
    {
      path: '/bookList',
      name: 'bookList',
      component: () => import('@/page/bookList/bookList.vue'),
      meta: {keepAlive:true},
    },  
    {
      path: '/detail',
      name: 'detail',
      component: () => import('@/page/detail/detail.vue'),
      meta: {keepAlive:false},
    },  
    {
      path: '/',
      redirect: '/'
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})

// 解决vue中的NavigationDuplicated报错
const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

 